module.exports = __webpack_public_path__ + "img/ClientInfo.30cff2d5.svg";